import { useState } from "react";

import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuListItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import PsiDiamond from "assets/psi-diamond.svg";
import BrandLogo from "assets/images/rc-logo.svg";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { globalStyles } from "shared/constants";
import { Box, List, ListItem } from "@mui/material";
import aboutStyles from "./style";

const AboutModal = ({ classes: passedClasses = {}, version = {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ListItem
        button
        onClick={evt => {
          evt.stopPropagation();
          setIsOpen(true);
        }}
      >
        <ListItemText primary={<Typography variant="body">About</Typography>} />
        <ListItemIcon sx={{ ...globalStyles.flex.justify.end, ...globalStyles.flex.justify.end }}>
          <InfoOutlinedIcon />
        </ListItemIcon>
      </ListItem>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle hasClose sx={aboutStyles.aboutHeading}>
          <Typography variant="h6">Emergency Response Locations</Typography>
          <IconButton aria-label="close" onClick={() => setIsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={aboutStyles.dialogContent}>

          <Box>
            <Divider sx={{ ...aboutStyles.divider }} />
            <Box sx={aboutStyles.group}>
              <Box sx={{ ...globalStyles.display.flex }}>
                <Typography variant='subtitle2' sx={{ ...globalStyles.margin(1, "Right") }}>Release</Typography>
                <Typography variant="subtitle2" sx={{ ...globalStyles.text.weight.bold }}>{version.release}</Typography>
              </Box>
            </Box>
            <Box sx={aboutStyles.group}>
              <Box sx={{ ...globalStyles.display.flex }}>
                <Typography variant='subtitle2' sx={{ ...globalStyles.margin(1, "Right") }}>Build</Typography>
                <Typography variant="subtitle2" sx={{ ...globalStyles.text.weight.bold }}>{version.build}</Typography>
              </Box>
            </Box>
            <Divider sx={{ ...aboutStyles.divider }} />
            <Box sx={aboutStyles.group}>
              <Box sx={{ ...globalStyles.display.flex}}>
                <Typography variant="subtitle2">Developed by: </Typography>
                <Typography variant="body1" sx={{ ...globalStyles.margin(1, "Left"), ...globalStyles.text.weight.bold }}>
                  RingCentral Professional Services
                </Typography>
              </Box>
              <img src={PsiDiamond} alt="PSI Logo" height={48} />
            </Box>
            <Divider sx={{ ...aboutStyles.divider }} />
            <Box sx={aboutStyles.group}>
              <img alt="Brand logo" src={BrandLogo} width={110} />
              <Typography variant="caption" sx={{ ...aboutStyles.copyrightlabel }}>
                Copyright &copy; 1999-2022 RingCentral, Inc. All rights reserved.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AboutModal;
